import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerState } from './customer.state';

export const getCustomerFeatureState = createFeatureSelector('customer');

export const selectCustomer = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.customer
);

export const selectCustomerValidation = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.validation
);

export const selectIsLoading = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.isLoading
);

export const selectIsLoadingPreLoan = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.isLoadingPreLoan
);

export const selectIsError = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.error
);

export const selectPreLoan = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.preLoan
);

export const selectRedirectUrl = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.redirectUrl
);

export const selectPreLoanId = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.id
);

export const selectCustomerCard = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.cardInfo
);

export const selectAvailableScore = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.score
);

export const selectAggregatorValidation = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.aggregatorValidation
);

export const selectMaxInstallmentValidation = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.maxInstallmentValidation
);

export const selectDebitDecisionValidation = createSelector(
  getCustomerFeatureState,
  (state: CustomerState) => state.debitDecisionValidation
);
